import { Component, Vue } from 'vue-facing-decorator';
import { TicketSelectionApplicationData, TicketSelectionDisplayModeState, usePromotionStore, useTicketSelectionDisplayStateStore } from "@/domain/ticket-selection";

@Component({
    name: "TicketSelectionDisplay",
})
export class TicketSelectionDisplay extends Vue {

    public readonly displayStateStore = useTicketSelectionDisplayStateStore();
    public readonly promotionStore = usePromotionStore();

    public get displayModeState(): TicketSelectionDisplayModeState {
        return this.displayStateStore.modeSelectionState;
    }

    public toggleAdditionalInformationVisibilityTo(val: boolean) {
        const additionalInfoElements: HTMLElement[] = Array.from(document.querySelectorAll('.p-ticketSelection__additionalInfo'));
        const footerElement = document.querySelector('[data-js=footer]') as HTMLElement;

        if (footerElement) {
            additionalInfoElements.push(footerElement);
        }

        additionalInfoElements.forEach((element: HTMLElement) => {
            element.style.display = val ? '' : 'none';
        });
    }

    public getCurrencyFrom(data: TicketSelectionApplicationData): string {
        if (!data) {
            return '';
        }

        if (data.priceList) {
            return data.priceList.currency ?? '';
        }

        return data.configuration.cartCurrency ?? data.configuration.poolCurrency;
    }
}
